import { createRouter, createWebHistory } from 'vue-router';

import HomeView from '@/views/HomeView.vue';
import SubmitOrder from '@/views/SubmitOrder.vue';
import OrderDetailsView from '@/views/OrderDetailsView.vue';
import LoginView from '@/views/LoginView.vue';
import AddUserView from '@/views/AddUserView.vue';
import OrdersView from '@/views/OrdersView.vue';
import ProfileView from '@/views/ProfileView.vue';
import AddStaffModal from '@/views/staffs/AddStaffModal.vue';
import VueJwtDecode from 'vue-jwt-decode';  // Make sure to install this


const routes = [
  {
    path : '/profile',
    name : 'Profile',
    component : ProfileView,
    meta: { requiresAuth: true },

  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path : '/addStaff',
    name : 'Add Staff',
    component : AddStaffModal,
    meta : { requiresAuth : true}
  },
  {
    path: '/register',
    name: 'Register',
    component: AddUserView,
    meta: { requiresAuth: false },
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: '/submit',
    name: 'Submit Order',
    component: SubmitOrder,
    meta: { requiresAuth: true },
  },
  {
    path: '/orderdetails',
    component: OrderDetailsView,
    meta: { requiresAuth: false },
  },
  {
    path: '/myorders',
    component: OrdersView,
    meta: { requiresAuth: true },
  },
  {
    path: '/',
    redirect: '/home',
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');

  if (to.meta.requiresAuth) {
    if (!token) {
      // No token found, redirect to login
      return next('/login');
    } else {
      try {
        // Decode and check token validity
        const decodedToken = VueJwtDecode.decode(token);
        const currentTime = Date.now() / 1000;

        // Check if token is expired
        if (decodedToken.exp < currentTime) {
          // Token is expired, redirect to login
          localStorage.removeItem('token');  // Clear invalid token
          return next('/login');
        } else {
          // Token is valid, proceed
          next();
        }
      } catch (error) {
        console.error('Error decoding token:', error);
        return next('/login');  // Invalid token, redirect to login
      }
    }
  } else {
    next();  // Route does not require authentication
  }
});

export default router;
